module.exports = __webpack_public_path__ + "static/media/bkg10d.dc2eabd6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/backgrounds/bkg10d.jpg
// module id = 473
// module chunks = 0